// Third-party
import React from 'react';
import { Switch, Route, withRouter, RouteComponentProps } from 'react-router';

// Components
import EnterpriseGroups from './EnterpriseGroups';
import EnterpriseGroupDetails from './EnterpriseGroupDetails';
import User from '@/types/user';
import EnterpriseAdminDetails from '@/types/enterprise-admin-details';
import EnterpriseAdminGroup from '@/types/enterprise-admin-group';
import EnterpriseGroup from '@/types/enterprise-group';

type ParentProps = {
  user: User;
  adminDetails: EnterpriseAdminDetails;
  groups: Array<EnterpriseAdminGroup>;
  onAddGroup: (name: string) => Promise<EnterpriseGroup>;
};

type Props = RouteComponentProps & ParentProps;

const AdminGroups: React.FC<Props> = (props: Props) => {
  const { user } = props;

  const onRowClick = (id: string) => {
    const { groups, history } = props;

    const group = groups.find(grp => grp._id === id);
    const groupId = group != null ? group._id : undefined;

    history.push(`/admin/groups/${groupId}`);
  };

  return (
    <div className="admin-enterprise group-tab">
      <Switch>
        <Route path="">
          <Route exact path="/admin/groups">
            <EnterpriseGroups onRowClick={onRowClick} />
          </Route>
          <Route path="/admin/groups/:id">
            <EnterpriseGroupDetails user={user} />
          </Route>
        </Route>
      </Switch>
    </div>
  );
};

export default withRouter(AdminGroups);
